import Docxtemplater from 'docxtemplater';
import PizZip from 'pizzip';
import { saveAs } from 'file-saver';

export const genDoc = async (template, obj, name) => {
    try {
        const response = await fetch(`/templates/${template}.docx`);
        const buffer = await response.arrayBuffer();
        const zip = new PizZip(buffer);
        const doc = new Docxtemplater(zip, {
            paragraphLoop: true,
            linebreaks: true,
        });
        doc.setData(obj)
        doc.compile();
        doc.render();
        const out = doc.getZip().generate({
            type: 'blob',
            mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        });
        let fn = name || 'generated-document.docx'
        saveAs(out, fn);
    } catch (error) {
        console.error('Ошибка генерации документа:', error);
        // @ts-ignore
        alert('Не удалось сгенерировать документ: ' + error.message);
    }
}